// const locHash = window.location.hash
const locHash = 'test-string'

const isTestHash = locHash.indexOf('is_test=true') !== -1
const isLangEnHash = locHash.indexOf('language=en') !== -1
const isLangRuHash = locHash.indexOf('language=ru') !== -1

export { isTestHash, isLangEnHash, isLangRuHash }
